<template>
  <div id="homepage-logos-container" v-if="logos.length > 0">
    <LoaderComponent v-if="!loaded" />
    <div id="homepage-logos">
      <div id="homepage-logos-label">
        {{ $t("iyog22_home_label") }}
      </div>
      <div class="logos-wrapper">
        <div class="logos-images-wrapper">
          <div class="logo-wrapper" v-for="logo in logos" :key="logo.imagePath">
            <a v-if="logo.url && logo.url.length > 0" :href="logo.url" target="_blank"
              class="tooltip">
              <img :src="logo.imagePath" :alt="logo.altText" />
              <span v-if="logo.altText && logo.altText.length > 0 && !lessThan724" class="tooltip-text">{{ logo.altText }}</span>
            </a>
            <a v-else class="tooltip">
              <img :src="logo.imagePath" :alt="logo.altText" />
              <span v-if="logo.altText && logo.altText.length > 0 && !lessThan724" class="tooltip-text">{{ logo.altText }}</span>
            </a>
            <!-- <div class="logo-label">{{ logo.label }}</div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>



<script>
import { loadLocaleMessages } from "../i18n.js";
import LoaderComponent from "./LoaderComponent.vue";
import media from "../mixins/media.js";
export default {
  name: "LogosComponent",
  mixins: [media],
  components: {
    LoaderComponent: LoaderComponent,
  },
  data() {
    return {
      loaded: false,
      lessThan724: window.matchMedia("(max-width: 724px)").matches,
      logos: [],
      urls: {
        portal: process.env.VUE_APP_PORTAL_URL
      },
    };
  },
  methods: {
    // Get logos
    loadLogos: function () {
      if (!this.$global.logos) {
        return axios({
          method: "GET",
          url: `${process.env.VUE_APP_DXA_ENDPOINT}/thg/galleries/self?hash=${process.env.VUE_APP_API_HASH}`,
        }).then(
          (result) => {
            this.$global.logos = result.data.logos;
            this.logos = result.data.logos;
            console.log(this.logos);
            this.loaded = true;
          },
          (error) => {
            console.error(error);
          }
        );
      } else {
        this.logos = this.$global.logos;
        this.loaded = true;
        return Promise.resolve();
      }
    },
  },
  mounted() {
    this.loadLogos();
    loadLocaleMessages("en");
  },
};
</script>



<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
#homepage-logos-container {
  width: 100%;
  color: black;
  background-color: white;
  border-bottom: 5px solid $theme-medium;
}

#homepage-logos {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  padding: 20px 50px;
}

#homepage-logos-label {
  color: $theme-dark;
  font-weight: bold;
  text-align: center;
}

.logos-wrapper {
  display: flex;
  flex-direction: column;
}
.logos-images-wrapper {
  @include flex-center;
  flex-wrap: wrap;
}
.logo-wrapper {
  @include flex-center;
  min-height: 90px;
  width: 90px;
  // filter: drop-shadow(1px 1px black);
  margin: 10px 20px;
}
  .tooltip {
    position: relative;
  }
    .tooltip .tooltip-text {
      position: absolute;
      bottom: 110%;
      left: 50%;
      visibility: hidden;
      width: auto;
      font-size: 80%;
      text-align: center;
      color: #fff;
      background-color: rgba(black, 0.8);
      border-radius: 6px;
      padding: 6px;
      margin-left: -50%;
      z-index: 1;
    }
      .tooltip .tooltip-text::after {
        content: "";
        position: absolute;
        top: 100%;
        left: 50%;
        margin-left: -5px;
        border-width: 5px;
        border-style: solid;
        border-color: rgba(black, 0.8) transparent transparent transparent;
      }
    .tooltip:hover .tooltip-text {
      visibility: visible;
    }
  .logos-images-wrapper a img {
    @include image-scale;
    object-fit: contain;
  }
  // .logo-label {
  //   @include flex-center;
  //   font-size: 80%;
  //   text-align: center;
  //   margin-top: 5px;
  // }

@media only screen and (max-width: 1199px) {
  
}

@media only screen and (max-width: 974px) {
  
}

@media only screen and (max-width: 724px) {
  
}

@media only screen and (max-width: 599px) {
  
}

@media only screen and (max-width: 499px) {
  
}
</style>